import { styled } from '@ltvco/refresh-lib/theme';

export const BoldSpan = styled('span')(() => ({
  fontWeight: 700,
}));
